import "jquery-touchswipe/jquery.touchSwipe";

import "bootstrap";

/* eslint-disable-next-line */
(function ($) {
	$(document).ready(function () {

		// get Cookies
		var getCookie = function (name) {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			if (parts.length == 2) return parts.pop().split(";").shift();
		};

		const topWaveDividerPath =
			'<path d="M0,17.174S110.281-10.837,358.828-.744,742.4,29.534,994.189,39.626,1366,26.934,1366,26.934V47.445H0Z" transform="translate(0 2.938)"/>';

		const bottomWaveDividerPath =
			'<path d="M1366,27.332s-110.281,28.011-358.828,17.918S623.6,14.973,371.811,4.88,0,17.572,0,17.572V-2.938H1366Z" transform="translate(0 2.938)"/>';

		$(".orange-block.block-divider-wave-ontop").prepend(getBlockDividerHtml("top", topWaveDividerPath, 50.383));
		$(".orange-block.block-divider-wave-onbottom").prepend(getBlockDividerHtml("bottom", bottomWaveDividerPath, 50.383));

		// If the url contains a hash, it might be trying to deep link to a specific tab on the page
		// Scroll to and open the tab if it exists
		// Only applies to tabs inside a Tab block
		if(window.location.hash !== ""){

			const linkedTab = $(".tabs-block-block.has-child-page-tab-content").find(".nav-tabs a[href='" + window.location.hash + "']");

			if(linkedTab.length > 0){

				let scrollPosition = linkedTab.offset().top - (parseInt($("body > header").outerHeight()) + 30);

				if($("#wpadminbar").length > 0){
					scrollPosition -= $("#wpadminbar").outerHeight();
				}

				$("html, body").animate({
					scrollTop: scrollPosition,
				}, 1000);

				linkedTab.click();

			}

		}

		// Updates browser's address bar by adding click tab's ID and a hash value, to simulate page navigation
		$(".tabs-block-block.has-child-page-tab-content").each(function(){

			$(".nav-tabs [data-toggle='tab']", this).on("click", function(){

				const tabId = $(this).attr("href");
				console.log(tabId);

				window.history.pushState(null, null, tabId);

			});

		});

		/**
		 * Bucket Blocks adding hashs and checking url
		 */
		$('.bucket-card button').click( function() {
			window.location.hash = this.dataset.id;
		});

		if(window.location.hash !== ""){

			const buttonBucket = $('.bucket-card button[data-id="' + window.location.hash.substring(1) + '"]');

			if(buttonBucket.length > 0){

				buttonBucket.click();

				var headerHeight = $('header').height();
				var buttonCardHeight = buttonBucket.parent().height();
				var negativeHeight = headerHeight + buttonCardHeight + 200;

				$('html, body').animate({
					scrollTop: $(window.location.hash).offset().top - negativeHeight ,
				}, 'slow');

			}

		}

		/**
		 * Video - Enable pause on modal close
		 */
		$('.orange-block.video-block.ID .modal').on('click', function (){
			$('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
		});

		/**
		 * Carousel - Add active class to first indicator
		 */
		$('.carousel-block .carousel-indicators li:first-of-type').addClass('active');



		/**
		 * Post Slider - Bootstrap mods
		 */
		$('.post-slider .carousel-inner .carousel-item:first-of-type').addClass('active');

		$.each( $('.post-slider-block .post-slider'), function(index, slider) {
			var sliderID = '#' + $(slider).attr('id');
			/*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
			$( this ).on('slide.bs.carousel', function (e) {
				var $e = $(e.relatedTarget);
				var idx = $e.index();
				var itemsPerSlide = 4;
				var totalItems = $(sliderID + ' .carousel-item').length;

				if (idx >= (totalItems - (itemsPerSlide - 1))) {
					var it = itemsPerSlide - (totalItems - idx);
					for (var i = 0; i < it; i++) {

						// append slides to end
						if (e.direction === "left") {
							$(sliderID + ' .carousel-item').eq(i).appendTo(sliderID + ' .carousel-inner');
						} else {
							$(sliderID + ' .carousel-item').eq(0).appendTo(sliderID + ' .carousel-inner');
						}
					}
				}
			});
		});

		$('.social-slider .carousel-inner .carousel-item:first-of-type').addClass('active');

		$.each( $('.social-slider-block .social-slider'), function(index, slider) {
			var sliderID = '#' + $(slider).attr('id');
			/*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
			$( this ).on('slide.bs.carousel', function (e) {
				var $eS = $(e.relatedTarget);
				var idxS = $eS.index();
				var itemsPerSlideS = 4;
				var totalItemsS = $(sliderID + ' .carousel-item.social').length;

				console.log('total: '+totalItemsS);

				if (idxS >= (4)) {
					var it = itemsPerSlideS - (totalItemsS - idxS);
					for (var i = 0; i < it; i++) {

						// append slides to end
						if (e.direction === "left") {
							$(sliderID + ' .carousel-item.social').eq(i).appendTo(sliderID + ' .carousel-inner.social');
						} else {
							$(sliderID + ' .carousel-item.social').eq(0).appendTo(sliderID + ' .carousel-inner.social');
						}
					}
				}
			});
		});		
		
			

		function getBlockDividerHtml(location, shapePath, shapeHeight = 50) {

			const dividerHtml =
				'<div class="block-divider-' + location + '">' +
					'<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1366 ' + shapeHeight + '" preserveAspectRatio="none">' +
						'<g fill="var(--' + location + '-divider-color, white)">' + shapePath + '</g>' +
					'</svg>' +
				'</div>';

			return dividerHtml;

		}

		/* Initialize Carousel */
		$('.carousel.ocb').carousel({
			pause: true,
		});

		/* Play trigger */
		$('.carousel-control-cycle-toggle').on("click", function() {

			var state = ($(this).hasClass("oc-pause")) ? 'cycle' : 'pause';

			var carouselId = $(this).closest(".carousel").attr("id");
			
			$("#" + carouselId).carousel(state);

			$(this).toggleClass("oc-pause");

		});


		/**
		 * Video - play video when modal opened
		 */
		$( '.video-block a.video-thumbnail-link' ).on( 'click', function () {
			$( this ).parent().find( 'video' ).trigger('play');
		});


		/**
		 * Testimonial - play/pause functionality
		 */
		/*$( '.testimonial-block a.carousel-control-pause' ).on( 'click', function(){
			var carousel = $( this ).parent().parent().attr( 'id' );

			if( $( this ).hasClass( 'paused' ) ) {
				$( '#' + carousel ).carousel('cycle');
				$( this ).toggleClass( 'paused' );

			} else {
				$( '#' + carousel ).carousel('pause');
				$( this ).toggleClass( 'paused' );
			}
		});*/

		// create function, it expects 2 values.
		/* eslint-disable-next-line */
		function insertAfter(newElement,targetElement) {
			// target is what you want it to go after. Look for this elements parent.
			var parent = targetElement.parent();
			//console.log(parent);

			// if the parents lastchild is the targetElement...
			if (parent.lastChild === targetElement) {
				// add the newElement after the target element.
				parent.appendChild(newElement);
			} else {
				// else the target has siblings, insert the new element between the target and it's next sibling.
				parent.insertBefore(newElement, targetElement.nextSibling);
			}
		}


		console.log('here');
		//need to change this to a dom listener
		setTimeout(function(){

			if($('#sb_instagram').length){
				var index = 1;
				$('.sbi_item').each(function(){
					var social_container = $('.social-container');
					if(index === 2){


						$(this).after(social_container);
						social_container.removeClass('hidden-unless-required');

					}

					index ++;

				})

			}

		},1000);

		/**
		 * Alert System
		 */
		$('#alert-carousel .carousel-inner .carousel-item:first-of-type').addClass('active');
		// Cookies
		function alertSetCookie(exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires="+d.toUTCString();
			document.cookie = 'hideAlerts' + "=" + true + ";" + expires + ";path=/";
		}

		$('#alert-system .close').click(function () { 
			alertSetCookie(7); // 7 days
		});

		var cookieVal = getCookie('hideAlerts');

		if (cookieVal) {
			$('#alert-system').hide();
		} else {
			$('#alert-system').show();
		}


	});
	/* eslint-disable-next-line */
})(jQuery);

